var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0.003 0.028L13.657 0.028 13.657 16.458 0.003 16.458z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4.583 2.75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    d: "M12.485.028H3.41c-.646 0-1.172.526-1.172 1.172v.748H1.172C.526 1.948 0 2.474 0 3.12v12.166c0 .646.526 1.172 1.172 1.172h9.075c.646 0 1.172-.526 1.172-1.172v-.749h1.066c.646 0 1.172-.525 1.172-1.171V1.2c0-.646-.526-1.172-1.172-1.172zm-2.004 15.258c0 .129-.105.234-.234.234H1.172c-.13 0-.235-.105-.235-.234V3.12c0-.13.106-.235.235-.235h1.066v10.48c0 .647.526 1.172 1.172 1.172h7.071v.749zm2.239-1.92c0 .129-.105.234-.235.234H3.41c-.13 0-.234-.105-.234-.234V1.2c0-.13.105-.235.234-.235h9.075c.13 0 .235.106.235.235v12.166z",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    d: "M11.385 2.939H4.51c-.26 0-.469.21-.469.468 0 .26.21.47.469.47h6.874c.258 0 .468-.21.468-.47 0-.258-.21-.468-.468-.468zM11.385 5.17H4.51c-.26 0-.469.21-.469.468 0 .26.21.47.469.47h6.874c.258 0 .468-.21.468-.47 0-.258-.21-.468-.468-.468zM11.385 7.4H4.51c-.26 0-.469.21-.469.47 0 .258.21.468.469.468h6.874c.258 0 .468-.21.468-.469 0-.258-.21-.468-.468-.468zM11.385 9.631H4.51c-.26 0-.469.21-.469.47 0 .258.21.468.469.468h6.874c.258 0 .468-.21.468-.469s-.21-.469-.468-.469z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.97aee7be8ee9a3aba7019edabb60fe17.svg";
export { ForwardRef as ReactComponent };